
import { HttpResult } from "widgets-for-react";
import { BasicCredentials, User, ChangePasswordData, VerifyResetPasswordTokenData, ResetPasswordData, ResendActivationData, ActivateAccountData } from "./components/portal/state";
import { Api } from "./components/portal/mocked_api";
import { parse_date } from "./generated_api";
import * as Models from './generated_models';
import { ExtraUserInfo } from "./components/portal_client";

export type LoginResult = HttpResult<{session_id:string, admin:Models.Admin} | {session_id:string, user:Models.User} | 
                                     {choose_role:"admin"|"user"}>
export async function login(x: BasicCredentials & {role?: string}, useTwoFactor?: string | false) : Promise<Api.LoginResult<ExtraUserInfo>> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')
  let res = await fetch("/api/portal/ApiLogin",
    {
      method: 'post', credentials: 'include',
      body: JSON.stringify({ Email: x.username, Password: x.password, Role:x.role?x.role : "" }),
      headers: headers
    })

  if (!res.ok) {
    return { status:"error generic not authorized" }
  }

  let json = await res.json()

  if (json.status === "error too many attempts") return json
  if (json.status === "error account not active") return { ...json, email: json.value }

  if (json.status != "success") {
    return { status: "error generic not authorized" }
  }

  if(json.role == "choose role"){
    return { status:"choose role", roles:json.value }
  }

  
  if(json.role == "admin"){
    let admin = parse_date<Models.Admin>(json.value)
    return { status:"success", role:"admin", session:json.session, user:{email:admin.Email, username:admin.Username} }
  }

  if(json.role == "user"){
    let user = parse_date<Models.User>(json.value)
    return { status:"success", role:"user", session:json.session, user:{email:user.Email, username:user.Username, firstname: user.FirstName, lastname: user.LastName, company: user.CompanyName, SAPId: user.SAPId} }
  }
  return { status:"error generic not authorized" }
}

export async function logout(u: User<ExtraUserInfo>, s: string, rootpath:string) : Promise<{}> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')

  await fetch("/api/portal/ApiLogout",
    {
      method: 'post', credentials: 'include',
      body: JSON.stringify({ SessionId:s }),
      headers: headers
    })

  return {}
}

export async function is_session_valid(email:string, session_id:string, role:string): Promise<HttpResult<"valid" | "invalid">> {
  const res = await fetch("/api/portal/IsSessionValid", {
    method: "post",
    credentials: "include",
    body: JSON.stringify({Email: email, CookieName: session_id, UserKind:role}),
    headers: {
      "content-type": "application/json",
      "X-XSRF-TOKEN": (document.getElementsByName("__RequestVerificationToken")[0] as any).value,
    },
  })
  if (!res.ok) { return {kind: "failed", status: 400}}
  const json = await res.json()
  return {kind: "result", status: 200, value: json.status == "error generic not authorized" ? "invalid" : json as boolean ? "valid" : "invalid"}
}


export async function change_password(
  u: User<ExtraUserInfo>,
  cpd: ChangePasswordData,
): Promise<Api.ChangePasswordResult> {
  const res = await fetch("/api/portal/ChangePassword", {
    method: "post",
    credentials: "include",
    body: JSON.stringify({
      Password: cpd.old_password,
      NewPassword: cpd.new_password,
      NewPasswordConfirmation: cpd.new_password_confirmed,
    }),
    headers: {
      "content-type": "application/json",
      "X-XSRF-TOKEN": (document.getElementsByName("__RequestVerificationToken")[0] as any).value,
    },
  })
  if (!res.ok) {
    const json = await res.json()
    console.error({json})
    return { status:"error missing fields" }
  }
  const json = await res.json()

  if (!json.status) {
    return { status:"error missing fields" }
  }

  return { status: json.status }
}

export async function request_reset_password(email: string): Promise<Api.ResetPasswordRequestResult> {
  const res = await fetch("/api/portal/ForgotPassword", {
    method: "post",
    credentials: "include",
    body: JSON.stringify({ Email: email }),
    headers: {
      "content-type": "application/json",
      "X-XSRF-TOKEN": (document.getElementsByName("__RequestVerificationToken")[0] as any).value,
    },
  })
  if (!res.ok) {
    const json = await res.json()
    throw Error(json.message)
  }
  const jsonRes: Api.ResetPasswordRequestResult = { status: "success" }

  return jsonRes
}

export async function request_activation_email(x: ResendActivationData): Promise<Api.ResendActivationResult> {
  const res = await fetch("/api/portal/RequestActivationEmail", {
    method: "post",
    credentials: "include",
    body: JSON.stringify({ Email: x.email }),
    headers: {
      "content-type": "application/json",
      "X-XSRF-TOKEN": (document.getElementsByName("__RequestVerificationToken")[0] as any).value,
    },
  })
  if (!res.ok) {
    const json = await res.json()
    throw Error(json.message)
  }
  let data = await res.json()
  if (data.status === "error too many attempts") return ({ status: "error too many attempts" })
  return ({status:"success"})
}
export async function reset_password(x: ResetPasswordData): Promise<Api.ResetPasswordResult> {
  const res = await fetch("/api/portal/ResetPassword", {
      method: "post",
      credentials: "include",
      body: JSON.stringify({ Token: x.reset_password_token, Email: x.email, Password: x.password, ConfirmPassword: x.confirmed_password }),
      headers: {
        "content-type": "application/json",
        "X-XSRF-TOKEN": (document.getElementsByName("__RequestVerificationToken")[0] as any).value,
      }
    })
    let data = await res.json()
    if (!data.status) return ({ status: "error token not found" })
    if (data.status === "success") return ({ status: "success", username: x.email })
    return ({ status: data.status })
  }

export async function activate_account(x: ActivateAccountData): Promise<Api.ActivateAccountResult<ExtraUserInfo>> {
    const res = await fetch("/api/portal/ActivateEmailWithToken", {
        method: "post",
        credentials: "include",
        body: JSON.stringify({ Token: x.token, Email: x.email}),
        headers: {
          "content-type": "application/json",
          "X-XSRF-TOKEN": (document.getElementsByName("__RequestVerificationToken")[0] as any).value,
        }
      })
    let data = await res.json()
    if (!data.status) return ({ status: "token expired", email: x.email})
    if (data.status === "success"){
      
      if(data.role == "admin"){
        let admin = parse_date<Models.Admin>(data.value)
        return { status:"success", role:"admin", session:data.session, user:{email:admin.Email, username:admin.Username} }
      }

      if(data.role == "user"){
        let user = parse_date<Models.User>(data.value)
        return { status:"success", role:"user", session:data.session, user:{email:user.Email, username:user.Username, firstname: user.FirstName, lastname: user.LastName, company: user.CompanyName} }
      }
    }
    if (data.status === "error token not found") return ({ status: "token not found" })
    if (data.status === "error account already active") return ({ status: "account already active" })
    if (data.status === "error token not valid") return ({ status: "token expired", email:x.email })    
    return ({ status: "token not found" })
  }

export let verifyResetPasswordToken = async ( x: VerifyResetPasswordTokenData): Promise<Api.ResetPasswordResult> => {
  const res = await fetch("/api/portal/VerifyResetPasswordToken", {
    method: "post",
    credentials: "include",
    body: JSON.stringify({
      Email: x.email,
      Token: x.reset_password_token,
    }),
    headers: {
      "content-type": "application/json",
      "X-XSRF-TOKEN": (document.getElementsByName("__RequestVerificationToken")[0] as any).value,
    },
  })
  if (!res.ok) {
    const json = await res.json()
    throw Error(json.message)
  }
  let data = await res.json()
  if (data.status) return ({ status: data.status })
  return ({ status: "error token not found" })
}
